<i18n
  src="@/locales/views/organization/production/query_by_provider/show_process.yml"
  lang="yaml"
></i18n>

<template>
  <div>
    <go-back-link
      :text="$t('labels.go_back_link')"
      :name="routeName('list_processes')"
      :params="{
        organization_id: this.organization_id
      }"
    ></go-back-link>

    <template v-if="load_general_data">
      <bread-crumbs :labels="[module_name, agro_exporter_process.name]" />

      <div class="mt-6 px-4">
        <tabs-container v-model="option_tabs" :with_routing="true" />
      </div>

      <router-view
        v-if="show_content_tab"
        :summary="summary"
        :providers_summary="providers_summary"
        :crop_size_summary="crop_size_summary"
      ></router-view>
    </template>
    <loading-message v-else />
  </div>
</template>

<script>
import Requester from "@/views/organization/requesters/production/query_by_provider/show_process.js";

export default {
  name: "OrgProductionQueryByProviderShowProcess",
  props: ["agro_exporter_process_id", "organization_id"],
  data() {
    return {
      load_general_data: false,
      load_data_summary: false,
      load_data_providers: false,
      option_tabs: [],
      agro_exporter_process: {},
      providers: [],
      summary: {},
      providers_summary: [],
      crop_size_summary: []
    };
  },
  computed: {
    show_content_tab: function () {
      const route_name = this.$route.name;
      if (
        (route_name == this.routeName("show_process_summary") &&
          this.load_data_summary) ||
        (route_name == this.routeName("show_process_providers"))
      ) {
        return true;
      }
      return false;
    }
  },
  methods: {
    fetchData: async function () {
      await this.fetchAgroExporterProcess();
      await this.loadDataByTab();
      this.load_general_data = true;
    },
    loadDataByTab: async function () {
      if (this.option_tabs[0].current && !this.load_data_summary) {
        await this.fetchSummary();
        await this.fetchProvidersSummary();
        await this.fetchCropSizeSummary();
        this.load_data_summary = true;
      }
      if (this.option_tabs[1].current && !this.load_data_providers) {
        // await this.fetchProviders();
      }
    },
    fetchAgroExporterProcess: async function () {
      let response = await Requester.fetchAgroExporterProcess(
        this.organization_id,
        this.agro_exporter_process_id
      );
      this.agro_exporter_process = response.data;
    },
    fetchProviders: async function () {
      let response = await Requester.fetchProviders(
        this.organization_id,
        this.agro_exporter_process_id
      );
      this.providers = response.data;
      this.load_data_providers = true;
    },
    fetchSummary: async function () {
      let response = await Requester.fetchSummary(
        this.organization_id,
        this.agro_exporter_process_id
      );
      this.summary = response.data;
    },
    fetchProvidersSummary: async function () {
      let response = await Requester.fetchProvidersSummary(
        this.organization_id,
        this.agro_exporter_process_id
      );
      this.providers_summary = response.data;
    },
    fetchCropSizeSummary: async function () {
      let response = await Requester.fetchCropSizeSummary(
        this.organization_id,
        this.agro_exporter_process_id
      );
      this.crop_size_summary = response.data;
    },
    fillOptions: function () {
      this.option_tabs = [
        {
          name: this.$t("labels.tabs.summary"),
          icon: "fa-solid fa-chart-pie",
          route: { name: this.routeName("show_process_summary") },
          current: this.$route.name == this.routeName("show_process_summary")
        },
        {
          name: this.$t("labels.tabs.providers"),
          icon: "fa-solid fa-users",
          route: { name: this.routeName("show_process_providers") },
          current: this.$route.name == this.routeName("show_process_providers")
        }
      ];
    }
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          organization_id: this.organization_id
        }
      }).then(() => {
        this.fillOptions();
        this.fetchData();
      })
    );
  },
  watch: {
    option_tabs() {
      this.loadDataByTab();
    }
  }
};
</script>
